import { Box } from '@mui/material'
import { getIn, useFormikContext } from 'formik'
import React from 'react'

import { IsItem } from '../../interfaces/IsItem'
import Select from '../Select'
import ErrorMessage from './ErrorMessage'

interface Props {
  name: string
  items: IsItem[]
  [otherProps: string]: any
}

const FormSelect: React.FC<Props> = ({ name, items, ...otherProps }) => {
  const { handleChange, setFieldTouched, errors, touched, values } = useFormikContext()

  return (
    <Box sx={{ mb: 2.5 }}>
      <Select
        fullWidth
        items={items}
        name={name}
        onBlur={() => setFieldTouched(name)}
        onChange={handleChange(name)}
        {...otherProps}
        value={getIn(values, name)}
      />
      <ErrorMessage error={getIn(errors, name)} visible={getIn(touched, name)} />
    </Box>
  )
}

export default FormSelect
